//import load_specs from "../specs/specs_parser";
//const process_specs = load_specs("process.yml");

const damage_rate_levels = ["gering", "mittel", "hoch", "sehr hoch"];
const risk_probability_levels = ["geringfügig", "überschaubar", "hoch", "sehr hoch"];
const victim_risk_levels = ["geringes Risiko", "Risiko", "hohes Risiko", "unbekannt"];

export default class ProcessCalculator {
  constructor(process, should_change_callback, change_callback) {
    this.p = process;
    this.change_callback = change_callback;
    this.should_change_callback = should_change_callback;
  }
  victim_risk() {
    let dr_idx = damage_rate_levels.indexOf(this.p.damage_rate);
    if (dr_idx === -1) {
      return victim_risk_levels[3];
    }
    let rp_idx = risk_probability_levels.indexOf(this.p.risk_probability);
    if (rp_idx === -1) {
      return victim_risk_levels[3];
    }
    let vr_idx = Math.min(Math.floor((dr_idx + rp_idx) / 2), 2);
    return victim_risk_levels[vr_idx];
  }
  update_value(value, field_name, field_label) {
    let old_value = this.p[field_name];
    this.p[field_name] = value;
    this.change_callback({
      field_name: field_name,
      old_value: old_value,
      new_value: value,
      message:
        `${field_label} wurde automatisch ermittelt und geändert.` +
        (old_value ? ` Alter Wert: "${old_value}"` : "") +
        ` Neuer Wert: "${value}".`,
    });
  }
  should_update_victim_risk() {
    this.should_update_value(
      "victim_risk",
      "Risiko für den Betroffenen",
      "Das Risiko ist proportional zu der Risikoschwere (also der Schwere eines eventuellen Schadenfalles) und der Schadenshäufigkeit. "
    );
  }
  should_update_assessment_necessary() {
    this.should_update_value(
      "assessment_necessary",
      "DSFA notwendig",
      "Wenn das Risiko für den Betroffenen sehr hoch ist, ergibt sich zwingend die Notwendigkeit für eine Datenschutzfolgenabschätzung (DSFA). Bitte konsultieren Sie in diesem Fall einen Datenschutzbeauftragten."
    );
  }
  should_update_value(field_name, field_label, update_explanation = "") {
    let value = this[field_name]();
    if (this.p[field_name] === null || this.p[field_name] === undefined) {
      // accept change silently
      this.update_value(value, field_name, field_label);
    } else if (value !== this.p[field_name]) {
      // ask user for consent via should_change_callback
      var self = this;
      this.should_change_callback({
        field_name: field_label,
        message: `Aus den gemachten Angaben ergibt sich ein neuer Wert für das Feld "${field_label}", der sich von dem bisherigen Wert unterscheidet. ${update_explanation} Soll der Wert angepasst werden?`,
        callback: (result) => {
          if (result.accept === true) {
            self.update_value(value, field_name, field_label);
          }
        },
      });
    }
  }
  assessment_necessary() {
    if (victim_risk_levels[2] === this.victim_risk()) {
      return true;
    }
    return false;
  }
  status_should_change_from_open_to_documented() {
    let process = this.p;
    if (process.status !== "OPEN") {
      return false;
    }
    if (
      process.text_header &&
      process.data_category.length > 0 &&
      process.dept_resp &&
      process.recipient_category &&
      process.delete_period &&
      process.damage_scenario &&
      process.damage_rate &&
      process.risk_probability &&
      process.victim_risk &&
      process.text_problem &&
      process.legal_basis &&
      process.legal_basis.constructor === Array &&
      process.legal_basis.length !== 0 &&
      process.text_legal
    ) {
      // check if text_problem and text_legal do not contain square brackets
      if (
        process.text_problem.search(/\[/) === -1 &&
        process.text_problem.search(/\]/) === -1 &&
        process.text_legal.search(/\[/) === -1 &&
        process.text_legal.search(/\]/) === -1
      ) {
        return true;
      } else {
        // found square brackets => should not mark text as complete.
        return false;
      }
    } else {
      return false;
    }
  }
  status_should_change_to_completed() {
    let process = this.p;
    let num_completed_measureSets = process.measureSets.filter((x) => x.status == "COMPLETED").length;
    let num_completed_measures = process.measures.filter((x) => x.status == "COMPLETED").length;
    if (
      num_completed_measureSets === process.measureSets.length &&
      num_completed_measures === process.measures.length
    ) {
      return true;
    } else {
      return false;
    }
  }
  status() {
    if (this.p.status === "OPEN" && this.status_should_change_from_open_to_documented()) {
      return "DOCUMENTED";
    } else if (this.p.status === "PLANNED" && this.status_should_change_to_completed()) {
      return "COMPLETED";
    } else if (this.p.status === "COMPLETED" && !this.status_should_change_to_completed()) {
      return "PLANNED";
    } else {
      return this.p.status;
    }
  }
  should_update_status(check_completed) {
    if (this.p.status === "OPEN" && this.status_should_change_from_open_to_documented()) {
      this.should_update_value(
        "status",
        "Status des Verfahrens",
        'Das Verfahren ist mit dem Status "offen" gekennzeichnet und alle für eine vollständige Dokumentation notwendigen Felder sind ausgefüllt. '
      );
    } else if (check_completed && this.p.status === "PLANNED" && this.status_should_change_to_completed()) {
      this.should_update_value(
        "status",
        "Status des Verfahrens",
        'Das Verfahren ist als "Maßnahmen spezifiziert" gekennzeichnet und alle Maßnahmen, also To-Dos und allgemeine TOMs (im Bezug auf dieses Verfahren) sind als erledigt markiert. '
      );
    } else if (check_completed && this.p.status === "COMPLETED" && !this.status_should_change_to_completed()) {
      this.should_update_value(
        "status",
        "Status des Verfahrens",
        'Das Verfahren ist als "Maßnahmen erledigt" gekennzeichnet und es gibt Maßnahmen, also To-Dos und allgemeine TOMs (im Bezug auf dieses Verfahren), die nicht als erledigt markiert sind. '
      );
    }
  }
}
